import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibDownloadSmallIconModule } from '../icons/lib-download-small-icon/lib-download-small-icon.module';
import { LibEditIconModule } from '../icons/lib-edit-icon/lib-edit-icon.module';
import { LibButtonComponent } from './lib-button.component';

@NgModule({
  declarations: [LibButtonComponent],
  imports: [CommonModule, LibEditIconModule, LibDownloadSmallIconModule],
  exports: [LibButtonComponent],
})
export class LibButtonModule {}
